/**
 * @generated SignedSource<<b7cc4daab24d032c9e13c3acb1178e74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsUpdateSchemaMutation$variables = {
  json: any;
  schemaId: number;
};
export type MutationsUpdateSchemaMutation$data = {
  readonly updateSchema: {
    readonly _id: number;
    readonly referencingSchemas: ReadonlyArray<{
      readonly _id: number;
    }>;
  };
};
export type MutationsUpdateSchemaMutation = {
  response: MutationsUpdateSchemaMutation$data;
  variables: MutationsUpdateSchemaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "json"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemaId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "json",
        "variableName": "json"
      },
      {
        "kind": "Variable",
        "name": "schemaId",
        "variableName": "schemaId"
      }
    ],
    "concreteType": "SchemaVersion",
    "kind": "LinkedField",
    "name": "updateSchema",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Schema",
        "kind": "LinkedField",
        "name": "referencingSchemas",
        "plural": true,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsUpdateSchemaMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MutationsUpdateSchemaMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "411c6200c5e6445d13f34a232565f613",
    "id": null,
    "metadata": {},
    "name": "MutationsUpdateSchemaMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsUpdateSchemaMutation(\n  $schemaId: Int!\n  $json: JsonScalar!\n) {\n  updateSchema(schemaId: $schemaId, json: $json) {\n    _id\n    referencingSchemas {\n      _id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03c1e07fbe750952f71a5e6780a52dc6";

export default node;
